import React, {FC} from 'react';
import Markdoc, {Config} from '@markdoc/markdoc';
import {LinkWithTransformations} from 'mkt-ssr/components/sail/Markdown/components/LinkWithTransformations/LinkWithTransformations';

const config: Config = {
  nodes: {
    link: {
      render: 'LinkWithTransformations',
      children: ['inline'],
      attributes: {
        id: {type: String},
        title: {type: String},
        href: {type: String},
      },
    },
  },
};

type MarkdownProps = {
  markdown: string;
};

export const Markdown: FC<React.PropsWithChildren<MarkdownProps>> = ({
  markdown,
}) => {
  const ast = Markdoc.parse(markdown);
  const content = Markdoc.transform(ast, config);
  // TODO: Create and Map React components
  const parsedContent = Markdoc.renderers.react(content, React, {
    components: {LinkWithTransformations},
  });

  return <>{parsedContent}</>;
};
